import React from 'react';
import { TrendingUp, DollarSign } from 'lucide-react';

/**
 * Секция формы для ввода параметров доходов
 */
const IncomeParametersSection = ({ 
  formData, 
  handleInputChange, 
  errors 
}) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
      <h3 className="col-span-full text-lg font-medium text-gray-900 dark:text-white mb-2 flex items-center gap-2">
        <TrendingUp className="w-5 h-5 text-green-500" />
        Доходы
      </h3>
      
      {/* Выручка от реализации */}
      <div>
        <label htmlFor="revenue" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
          <DollarSign className="w-4 h-4 mr-1 text-green-500" />
          Выручка от реализации
        </label>
        <input
          type="text"
          id="revenue"
          name="revenue"
          value={formData.revenue}
          onChange={handleInputChange}
          className={`form-input w-full ${errors.revenue ? 'input-error' : ''}`}
          placeholder="Введите сумму"
        />
        {errors.revenue && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.revenue}
          </p>
        )}
        <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
          Общая сумма доходов от реализации товаров, работ и услуг
        </p>
      </div>

      {/* Внереализационные доходы */}
      <div>
        <label htmlFor="otherIncome" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
          <DollarSign className="w-4 h-4 mr-1 text-green-500" />
          Внереализационные доходы
        </label>
        <input
          type="text"
          id="otherIncome"
          name="otherIncome"
          value={formData.otherIncome}
          onChange={handleInputChange}
          className={`form-input w-full ${errors.otherIncome ? 'input-error' : ''}`}
          placeholder="Введите сумму"
        />
        {errors.otherIncome && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.otherIncome}
          </p>
        )}
        <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
          Доходы, не связанные с основной деятельностью (проценты, курсовые разницы, штрафы полученные и т.д.)
        </p>
      </div>

      {/* Информационный блок */}
      <div className="col-span-full mt-2">
        <div className="p-3 bg-green-50 dark:bg-green-900/20 border border-green-100 dark:border-green-800 rounded-lg">
          <div className="flex items-start">
            <TrendingUp className="w-5 h-5 text-green-600 dark:text-green-400 mr-3 mt-0.5" />
            <div>
              <h4 className="text-sm font-medium text-green-700 dark:text-green-300 mb-1">
                О доходах для целей налогообложения
              </h4>
              <p className="text-xs text-green-600 dark:text-green-400">
                Согласно ст. 248 НК РФ доходы делятся на доходы от реализации и внереализационные доходы. К доходам от реализации относится выручка от реализации товаров, работ, услуг и имущественных прав. К внереализационным - доходы от долевого участия, положительные курсовые разницы, штрафы за нарушение договорных обязательств и др. (ст. 250 НК РФ).
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IncomeParametersSection;